import { RouteLocationNormalized } from 'vue-router'

export default {
  routes: [
    {
      name: 'operations_add',
      path: '/operations/add',
      component: () => import('./views/TheOperationsActions.vue'),
    },
    {
      name: 'operations_counterparty_in',
      path: '/operations_counterparty_in/add',
      component: () => import('./views/TheOperationsActions.vue'),
    },
    {
      name: 'operations_counterparty_out',
      path: '/operations_counterparty_out/add',
      component: () => import('./views/TheOperationsActions.vue'),
    },
    {
      name: 'operations_in',
      path: '/operations_in/add',
      component: () => import('./views/TheOperationsActions.vue'),
    },
    {
      path: '/operations_in',
      redirect: (to: RouteLocationNormalized) => {
        if (to.query.tab === 'add') {
          const query = to.query

          query.tab = undefined
          return {
            path: '/operations_in/add',
            query
          }
        }
      },
    }
  ]
}
